export default __webpack_public_path__ + "images/dfccade3f7b066d28b39abd8963134ec.png";